import { useEffect, useState } from "react";
import { useFetchMyModeratorProfile } from "./queries/moderators/useFetchMyModeratorProfile.js";

// Cannot useAuth here because useMyModerator is used in SiteHeaderProvider shared by all
import { useCurrentUserContext } from "contexts/CurrentUserContext";

export const useMyModerator = () => {
    const [profileFetched, setProfileFetched] = useState(false);
    const [myModProfile, setMyModProfile] = useState(null);
    const { fetchMyModeratorProfile } = useFetchMyModeratorProfile();
    const currentUserContext = useCurrentUserContext();
    const currentUserId =
        currentUserContext?.currentUser?.data?.currentUser?.id;

    // Optimization: We only check Authenticated users for a moderator profile
    useEffect(() => {
        if (!currentUserId) {
            setProfileFetched(true); // no profile to fetch
            return;
        }

        const getMyModProfile = async () => {
            const profile = await fetchMyModeratorProfile();
            setMyModProfile(profile);
            setProfileFetched(true);
        };

        getMyModProfile();
    }, [currentUserId]);

    return {
        profileFetched,
        myModProfile
    };
};
